const SENTINEL_SELECTOR = '[data-infinite-scroll-sentinel]'
const PRODUCT_CARD_SELECTOR = '[product-card]'
const GRID_SELECTOR = 'collection-products-grid'
const ROOT_MARGIN = '0px 0px 300% 0px'

class CollectionProductsGrid extends HTMLElement {
  constructor() {
    super()

    this.isLoading = false
    this.nextUrl = null
    this.sentinel = null
    this.observer = null
    this.abortController = null

    this.handleIntersect = this.handleIntersect.bind(this)
  }

  connectedCallback() {
    this.nextUrl = this.dataset.nextUrl || null
    this.sentinel = this.id
      ? document.querySelector(`${SENTINEL_SELECTOR}[data-sentinel-for="${this.id}"]`)
      : null

    if (!this.nextUrl || !this.sentinel) {
      this.stop()

      return
    }

    this.observer = new IntersectionObserver(this.handleIntersect, { rootMargin: ROOT_MARGIN })
    this.observer.observe(this.sentinel)
  }

  disconnectedCallback() {
    this.observer?.disconnect()
    this.observer = null
    this.abortController?.abort()
    this.abortController = null
  }

  async handleIntersect(entries) {
    const entry = entries[0]

    if (!entry.isIntersecting || this.isLoading) {
      return
    }

    if (!this.nextUrl) {
      this.stop()

      return
    }

    this.isLoading = true
    this.setAttribute('aria-busy', 'true')
    this.abortController = new AbortController()

    try {
      const doc = await this.fetchPage(this.nextUrl, this.abortController.signal)

      doc.querySelectorAll(PRODUCT_CARD_SELECTOR).forEach((card) => this.appendChild(card))

      const nextGrid = doc.querySelector(GRID_SELECTOR)

      this.nextUrl = nextGrid?.dataset.nextUrl || null

      if (!this.nextUrl) {
        this.stop()
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('[collection-products-grid]', error)
      }
    } finally {
      this.isLoading = false
      this.abortController = null

      if (this.isConnected) {
        this.setAttribute('aria-busy', 'false')
      }
    }
  }

  async fetchPage(url, signal) {
    const response = await fetch(url, { credentials: 'same-origin', signal })

    if (!response.ok) {
      throw new Error(`Failed to fetch ${url} (${response.status})`)
    }

    const html = await response.text()

    return new DOMParser().parseFromString(html, 'text/html')
  }

  stop() {
    this.observer?.disconnect()
    this.observer = null
    this.sentinel?.remove()
    this.sentinel = null
  }
}

customElements.get('collection-products-grid') ||
  customElements.define('collection-products-grid', CollectionProductsGrid)
